<template>
  <RouterView id="app" v-if="isRouterAlive" class="app" />
</template>

<script>
export default {
  data () {
    return {
      isRouterAlive: true,
    }
  },

  created () {
    // 接收聊天窗口消息并执行相应方法
    window.addEventListener('message', (event) => {
      const action = this[event.data?.action]
      if (typeof action === 'function') action()
    })
  },

  methods: {
    // 刷新页面
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => (this.isRouterAlive = true))
    },
  },
}
</script>

<style lang="stylus" scoped>
  .app
    position relative
    box-sizing border-box
    min-height 100%
    color $black
    min-width $design-width
    clearfix() // 触发 BFC
    // background $bgcolor
</style>
